export const analyticsStrings = {
  ru: {
    'tab.identification': 'Идентификация',
    'tab.executive': 'Руководителю',
    'tab.cohorts': 'Когорты',
    'tab.subscriptions': 'Подписка',
    'tab.metrics': 'Метрики',
    'tab.exports': 'Выгрузки',
    'tab.policy': 'Определения',
    'tab.forecast': 'Прогноз загрузки',

    'period.day': 'Сутки',
    'period.week': 'Неделя',
    'period.month': 'Месяц',
    'period.quarter': 'Квартал',

    'tile.unidentified': 'Доля неидентифицированных',
    'tile.identified': 'Доля идентифицированных',
    'tile.visits': 'Визитов в расчёте',
    'tile.declined': 'Отказов',
    'tile.excluded': 'Служебных исключено',

    'reason.title': 'Причины отказа',
    'reason.code': 'Причина',
    'reason.visits': 'Визитов',
    'reason.share': 'Доля отказов',

    'shift.title': 'По сменам',
    'shift.opened': 'Открыта',
    'operator.title': 'По операторам',
    'operator.name': 'Оператор',
    'history.title': 'История по дням',
    'history.day': 'День',

    'common.visits': 'Визиты',
    'common.identified': 'Идентифицировано',
    'common.share': 'Доля',
    'common.site': 'Объект',
    'common.orders': 'Заказы',
    'common.grossRevenue': 'Выручка (валовая)',
    'common.refunds': 'Возвраты',
    'common.subscriptionRevenue': 'Абонентская плата',
    'common.revenue': 'Выручка (чистая)',
    'common.averageCheck': 'Средний чек',
    'common.total': 'Итого',
    'common.loading': 'Загрузка…',
    'common.empty': 'Данных за период нет',
    'common.refresh': 'Обновить',

    'cohort.month': 'Когорта',
    'cohort.size': 'Размер',
    'cohort.retention': 'Возврат по месяцам',
    'cohort.visits': 'Визитов',
    'cohort.repeatVisits': 'Повторных визитов',
    'cohort.repeatShare': 'Доля с ≥ 2 визитами',
    'cohort.perCustomer': 'Визитов на клиента',

    'subscription.activated': 'Подключено',
    'subscription.cancelled': 'Отписалось',
    'subscription.active': 'Действует',
    'subscription.churn': 'Отток',
    'subscription.uses': 'Использований',
    'subscription.bySite': 'По объектам: подключения и отток — по объекту оформления, использования — по месту визита',
    'subscription.subscriptions': 'Подписок использовано',

    'metric.title': 'Метрика',
    'metric.value': 'Значение',
    'metric.formula': 'Как считаем',
    'metric.source': 'Источник истины',
    'metric.note':
      'Дашборд и отчёты берут эти определения из одного места: расхождение цифр — дефект.',

    'policy.title': 'Определение идентифицированного визита',
    'policy.rule': 'Правило',
    'policy.rule.linked': 'Есть привязка к профилю',
    'policy.rule.verified_phone': 'Привязка и подтверждённый телефон',
    'policy.rule.consented': 'Привязка, телефон и действующее согласие',
    'policy.excludeService': 'Исключать служебные автомобили',
    'policy.save': 'Сохранить определение',
    'policy.saved': 'Определение сохранено',
    'policy.note':
      'Определение общее для дашборда, отчётов и метрик: расхождение цифр между экранами — дефект, а не разные точки зрения.',

    'export.title': 'Выгрузка данных',
    'export.hint':
      'Файл скачивается сразу. Каждая выгрузка попадает в журнал ниже — с составом, числом строк и пометкой о персональных данных.',
    'export.truncated': ' · выгрузка обрезана по лимиту строк',
    'export.dataset': 'Набор данных',
    'export.format': 'Формат',
    'export.run': 'Выгрузить',
    'export.pii': 'Содержит персональные данные',
    'export.rows': 'Строк',
    'export.log': 'Журнал выгрузок',
    'export.when': 'Когда',
    'export.scope': 'Состав',
    'export.download': 'Скачать',
    'export.kind': 'Вид',
    'export.kind.mart': 'Агрегат',
    'export.kind.rows': 'Построчно',
    'export.api':
      'По API: GET /api/v1/reports/export/{набор}?format=csv&from=…&to=…&offset=… — тот же журнал и те же права.',

    'forecast.pickSite': 'Выберите объект в шапке, чтобы построить прогноз',
    'forecast.location': 'Координаты объекта',
    'forecast.latitude': 'Широта',
    'forecast.longitude': 'Долгота',
    'forecast.saveLocation': 'Сохранить координаты',
    'forecast.sync': 'Загрузить погоду и переобучить',
    'forecast.noLocation': 'Для объекта не заданы координаты — без них погоду не получить.',
    'forecast.day': 'День',
    'forecast.weather': 'Погода',
    'forecast.expected': 'Ожидаем визитов',
    'forecast.range': 'Интервал 80 %',
    'forecast.calendar': 'Среднее по дню недели',
    'forecast.quality': 'Точность модели',
    'forecast.qualityNote':
      'Ошибка на последних {holdout} днях истории, которых модель не видела: модель {mape}, календарь {baseline}. Обучено на {days} днях.',
    'forecast.recent': 'Последние дни: факт и модель',
    'forecast.actual': 'Факт',
    'forecast.predicted': 'Модель',

    'marts.title': 'Витрины для BI',
    'marts.view': 'Витрина',
    'marts.populated': 'Наполнена',
    'marts.rows': 'Строк',
    'marts.refresh': 'Наполнить витрины',
    'marts.note':
      'BI читает витрины на реплике и не обращается к боевым таблицам: доступ выдан роли moika_bi.',
  },
} as const;

export type AnalyticsKey = keyof typeof analyticsStrings.ru;
export type AnalyticsTranslate = (key: AnalyticsKey) => string;

export function makeAnalyticsT(): AnalyticsTranslate {
  return (key) => analyticsStrings.ru[key] ?? key;
}

export function percent(value: number): string {
  return `${Math.round(value * 1000) / 10}%`;
}

export function money(minor: number): string {
  return `${Math.round(minor / 100).toLocaleString('ru-RU')} ₸`;
}
